// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c1NJ3{padding:1rem;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}@media(max-width:1023px){.c1NJ3{-ms-flex-direction:column;flex-direction:column}}.c1NJ3:not(:last-child){border-bottom:1px solid #dcdddd}._3qj-2{font-size:16px;font-size:1rem;line-height:26px;line-height:1.625rem}._1J8G9,._3qj-2{font-weight:300;font-family:var(--base-font)}._1J8G9{font-size:14px;font-size:.875rem;line-height:23px;line-height:1.4375rem}@media(max-width:767px){._1J8G9{font-size:1rem;line-height:1.625rem}}._1asNZ{color:#f45858}._1asNZ:before{content:\"\";display:inline-block;background-color:#f45858;margin-right:.5rem;position:relative;top:-1px;border-radius:50%;width:8px;width:.5rem;height:8px;height:.5rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "c1NJ3",
	"title": "_3qj-2",
	"time": "_1J8G9",
	"isLive": "_1asNZ"
};
module.exports = exports;
